import type { ButtonHTMLAttributes } from "react";

export function CtaButton({ className = "", ...props }: ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      className={`mt-3.5 block w-full rounded-inner bg-gradient-to-b from-[#3F7BFF] to-accent px-4 py-[15px] font-display text-[19px] font-bold uppercase tracking-[0.08em] text-white shadow-cta disabled:opacity-40 ${className}`}
      {...props}
    />
  );
}
